import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import VariableForm from "components/variables/VariableForm";
import { createVariable } from "graphql/mutations";

const VariableCreateForm = ({ onSuccess }) => {
  const navigate = useNavigate();
  const variable = {
    name: "",
    description: "",
    shortName: "",
    unit: "",
    derived: false,
    groupType: "1",
    type: "numeric",
  };

  async function onSubmit(values) {
    try {
      const { name, description, shortName, unit, derived, groupType, type } =
        values;

      await API.graphql({
        query: createVariable.replaceAll("__typename", ""),
        variables: {
          input: {
            name,
            description,
            shortName,
            unit,
            derived,
            groupType,
            type,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/variables");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <VariableForm onSubmit={onSubmit} initialValues={variable} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Variable",
    successAdded: "Variable agregada con éxito",
    responses: {},
  },
});

export default VariableCreateForm;
